// Site-wide motion language. One source of truth for easing, duration,
// and stagger — components should reference these instead of picking their
// own numbers. If a new value is genuinely needed, add it here first so it
// stays reusable rather than becoming another one-off in a component.
//
// Usage:
//   import { duration, ease, stagger, fadeUp } from '../lib/motion'
//   <motion.div {...fadeUp(i)} />
//   transition={{ duration: duration.base, ease: ease.out, delay: i * stagger.base }}

// Site-wide motion language. One source of truth for easing, duration,
// and stagger — components should reference these instead of picking their
// own numbers. If a new value is genuinely needed, add it here first so it
// stays reusable rather than becoming another one-off in a component.
//
// Usage:
//   import { duration, ease, stagger, fadeUp } from '../lib/motion'
//   <motion.div {...fadeUp(i)} />
//   transition={{ duration: duration.base, ease: ease.out, delay: i * stagger.base }}
//
// Mobile runs every one of these ~35% faster than desktop — same
// animations, same sequencing, just less time spent waiting on a small
// screen where a visitor is more likely to be scrolling quickly. Checked
// once at module load (client-side only; server/prerender has no
// `window`, so the static HTML always uses desktop timing — harmless,
// since animations only run after hydration anyway). Every component
// that imports `duration`/`stagger` gets this automatically; nothing
// else needed to change.
const IS_MOBILE = typeof window !== 'undefined' && window.innerWidth <= 767
const MOBILE_SCALE = 0.65
const scale = (n) => (IS_MOBILE ? Math.round(n * MOBILE_SCALE * 1000) / 1000 : n)

export const duration = {
  fast: scale(0.25), // micro-interactions: buttons, toggles, hover states
  base: scale(0.4), // default reveal — most cards, list items, section content
  slow: scale(0.6), // hero-level or large-surface reveals
}

export const ease = {
  out: 'easeOut', // reveals entering the viewport (the default)
  inOut: 'easeInOut', // looping/continuous motion (tickers, marquees)
}

// Multiplier for staggered lists: delay = index * stagger.<size>
export const stagger = {
  tight: scale(0.05), // dense grids, many items (6+)
  base: scale(0.08), // default — most card/list reveals
  loose: scale(0.12), // a few large, deliberate items (2–4)
}

// Named delay presets for fixed (non-index-based) sequencing, e.g. a hero's
// headline → subhead → CTA appearing in sequence.
export const sequenceDelay = {
  first: 0,
  second: 0.1,
  third: 0.2,
  fourth: 0.4,
  fifth: 0.6,
}

// Shared initial/animate/transition presets for the most common pattern
// site-wide: fade up on reveal, optionally staggered by index.
export function fadeUp(index = 0, { size = 'base', delay: fixedDelay } = {}) {
  return {
    initial: { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: {
      duration: duration.base,
      ease: ease.out,
      delay: fixedDelay ?? index * stagger[size],
    },
  }
}

// Same as fadeUp but for content that should animate immediately on mount
// (e.g. hero content) rather than on scroll into view.
export function fadeUpOnMount(index = 0, { size = 'base', delay: fixedDelay } = {}) {
  return {
    initial: { opacity: 0, y: 16 },
    animate: { opacity: 1, y: 0 },
    transition: {
      duration: duration.base,
      ease: ease.out,
      delay: fixedDelay ?? index * stagger[size],
    },
  }
}
